import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const BoatType = ({ boatClass }: SpecProps<"boat_class">) => {
  const { i18n } = useLingui();

  if (boatClass == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.boat_class",
    message: "Type",
    comment: "Field for 'type' in ad specification",
  });
  return <FieldValuePair field={field} value={boatClass.value} />;
};
